import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false // NOSONAR
})
export class FooterComponent {
  constructor() { }

  ngOnInit(): void { // NOSONAR 

  }
}